import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { DropdownDivider } from 'foundations-components/transitional/components/Dropdown';
import { getQuarantineUrl } from 'FormsUI/lib/RouteGenerators';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const QuarantineAction = () => /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx(DropdownDivider, {}), /*#__PURE__*/_jsxs(Button, {
    use: "secondary",
    href: getQuarantineUrl(),
    onClick: () => trackDashboardInteraction('go-to-submissions-spam-actions'),
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.spam"
    }), /*#__PURE__*/_jsx(Badge, {
      use: "beta",
      marginInlineStart: "400",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "beta"
      })
    })]
  })]
});
export default QuarantineAction;